import { Component, OnInit } from '@angular/core';
import { PolicyService } from '../../../policy/policy.service';

@Component({
  selector: 'app-cancel-operation',
  templateUrl: './cancel-operation.component.html',
  styleUrl: './cancel-operation.component.scss'
})
export class CancelOperationComponent implements OnInit {

  operationDescription: string = null;

  constructor(
    private _policyService: PolicyService
  ) { }

  ngOnInit() {
    this.setOperationDescription();
  }

  setOperationDescription(): void {
    switch (this.operationId) {
      case '_ARIST':
        this.operationDescription = 'del riscatto totale';
        break;
      case '_ARISP':
        this.operationDescription = 'del riscatto parziale';
        break;
      case '_ANAPP':
        this.operationDescription = "dell'appendice";
        break;
    }
  }  

  get operationId(): string {
    return this._policyService.operationId;
  }

}
